import React, { createContext, useContext, useState, useEffect } from 'react';

const LayoutContext = createContext();

// eslint-disable-next-line react-refresh/only-export-components
export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};

const STORAGE_KEY = 'polka_feedLayout';

export const LayoutProvider = ({ children }) => {
  // Флаг «новой» вёрстки ленты (VK-стиль): центрирование по 405px и одна карточка в ряду.
  // Экспериментальная фича — хранится локально у пользователя.
  const [newFeedLayout, setNewFeedLayout] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : false;
    } catch {
      console.warn('Некорректное значение feedLayout в localStorage, сбрасываю в false');
      return false;
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newFeedLayout));
  }, [newFeedLayout]);

  return (
    <LayoutContext.Provider value={{ newFeedLayout, setNewFeedLayout }}>
      {children}
    </LayoutContext.Provider>
  );
};